import axios from 'axios';
import {
  RequestParamsModel,
  RequestParamsMultipartFormModel,
  RequestParamsMultipartModel,
} from '../types/requestParamsModel';

const errorMessageHandler = (response) => {
  if (response.data && response.data.error === 'RAFFLE_IS_ACTIVE') return 'Raffle is active';
  if (response.data && response.data.error === 'PROPERTY_HAS_ACTIVE_RAFFLE') return 'Property has active raffle';
  return response;
};

const agent = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // `https://b653dd9653de.ngrok.io/api`,

  // process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const send = ({ method, url, data, params, token, responseType }: RequestParamsModel) => {

  const headers = token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
  return agent
    .request({
      method,
      url,
      headers,
      data,
      params,
      responseType: responseType || 'json',
    })
    .catch((err) => {
      if (err.response) {
        const errorResponse = errorMessageHandler(err.response);
        return Promise.reject(errorResponse);
      } else if (err.request) {
        // no response received (network error / timeout)
        const message =
          err.code === 'ECONNABORTED'
            ? 'Request timeout — server took too long to respond'
            : 'No response from server';

        return Promise.reject({
          message,
          status: 504,
          code: err.code || 'NO_RESPONSE',
        });
      } else {
        return Promise.reject({
          message: err.message || 'Unexpected error',
          status: 500,
        });
      }
    });
};

const sendMultipart = ({ method, url, multipartData = [], params, token }: RequestParamsMultipartModel) => {
  const headers = token
    ? {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      }
    : { 'Content-Type': 'multipart/form-data' };

  let data = new FormData();
  multipartData.map((image: any) => {
    data.append(image.id, image.image);
  });
  return agent
    .request({
      method,
      url,
      headers,
      data,
      params,
    })
    .catch((error) => {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx.
        throw error.response;
      } else if (error.request) {
        // The request was made but no response was received.
        throw new Error('OOPS');
      } else {
        // Something happened in setting up the request that triggered an Error
        throw new Error('OOPS');
      }
    });
};

export { send, sendMultipart };
